import { render, staticRenderFns } from "./PolinizationDetails.vue?vue&type=template&id=5e635aef&scoped=true&lang=html&"
import script from "./PolinizationDetails.vue?vue&type=script&lang=js&"
export * from "./PolinizationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e635aef",
  null
  
)

export default component.exports